import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from "react-redux";
import { CommonAxiosGet } from "./CommonUtils/CommonAxios";
import { useNavigate } from "react-router-dom";

function SidebarPanchayat() {

  const dispatch = useDispatch();
  const RoleId = useSelector((state) => state.reducers?.commonmastersreducer?.dualroles);

  const navigate = useNavigate();

  const [modules, setModules] = useState([]);
  const [subModules, setSubModules] = useState([]);

  const [isOpen, setIsOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);

  // ✅ Tooltip
  const renderTooltip = (text) => (
    <Tooltip id={`tooltip-${text}`}>{text}</Tooltip>
  );

  // ✅ Fetch API
  const fetchModulesDetails = async () => {
    if (RoleId > 0) {
      const response = await CommonAxiosGet(`sidebar/modulesdata/${RoleId}`);
      const { scode, data } = response.data;

      if (scode === "01") {
        const uniqueMap = new Map();

        data.forEach(item => {
          const key = `${item.module_id}-${item.module_name}`;
          if (!uniqueMap.has(key)) {
            uniqueMap.set(key, item);
          }
        });

        setModules(Array.from(uniqueMap.values()));
        setSubModules(data);
      }
    }
  };

  useEffect(() => {
    fetchModulesDetails();
  }, [RoleId]);

  // ✅ Responsive sidebar
  useEffect(() => {
    const handleResize = () => {
      setIsOpen(window.innerWidth > 576);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Dropdown toggle
  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  // ✅ Click handler (Redux)
  const handleMenuClick = (submodule) => {

    setActiveMenu(submodule.submodule_name);

    setOpenDropdown(submodule.module_name);

    dispatch({
      type: "MODULES_SIDE_BAR_DATA",
      payload: submodule
    });

    dispatch({
      type: "ACTIVE_TAB",
      payload: 0
    });

    // IMPORTANT
    navigate("/sidebar");
  };

  const modulesData = useSelector(
    (state) => state.reducers?.servicedashboardreducer?.modulesSideBarData
  );

  useEffect(() => {

    if (modulesData?.module_name) {

      // keep dropdown open
      setOpenDropdown(modulesData.module_name);

      // active submenu
      setActiveMenu(modulesData.submodule_name);
    }

  }, [modulesData]);



  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>

      {/* Toggle */}
      <button className="toggle-btn-menu" onClick={() => setIsOpen(!isOpen)}>
        {isOpen
          ? <img src="../images/left-menu.svg" className="img-fluid left-menu" alt="" />
          : <img src="../images/right-menu.svg" className="img-fluid right-menu" alt="" />}
      </button>

      <ul>
        {modules.map((module) => (
          <li
            key={module.module_id}
            className={`dropdown 
              ${openDropdown === module.module_name ? "open" : ""} 
              ${activeMenu === module.module_name ? "active" : ""}`}
          >

            {/* Module */}
            <OverlayTrigger
              placement="right"
              overlay={renderTooltip(module.module_name)}
              container={document.body}
            >
              <div
                className="dropdown-title"
                role="button"
                tabIndex={0}
                onClick={() => toggleDropdown(module.module_name)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    toggleDropdown(module.module_name);
                  }
                }}
              >
                <img
                  src={
                    module.src_img_name
                      ? `/images/${module.src_img_name}`
                      : `/images/default.svg`
                  }
                  alt={module.module_name}
                />

                <span className="dropdown-text">
                  {module.module_name}
                </span>
              </div>
            </OverlayTrigger>

            {/* SubModules */}
            {openDropdown === module.module_name && (
              <ul className="submenu">
                {subModules
                  .filter(sub => sub.module_id === module.module_id)
                  .map(sub => (
                    <OverlayTrigger
                      key={sub.submodule_id}
                      placement="right"
                      overlay={renderTooltip(sub.submodule_name)}
                      container={document.body}
                    >
                      <li
                        className={
                          activeMenu === sub.submodule_name
                            ? "active"
                            : ""
                        }
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                          handleMenuClick({
                            ...sub,
                            module_name: module.module_name
                          })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            handleMenuClick({
                              ...sub,
                              module_name: module.module_name
                            });
                          }
                        }}
                      >
                        <img
                          src="../images/next.svg"
                          className="sub-arrow-icon"
                          alt=""
                        />

                        <span>{sub.submodule_name}</span>
                      </li>
                    </OverlayTrigger>
                  ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SidebarPanchayat;